module.exports = __webpack_public_path__ + "img/bttn_yellow_pin.eac40ad9.png";